module.exports = __webpack_public_path__ + "static/rvajs2018-8507d0f383db9595cd8d7acb1329c68e.jpeg";